import { Box } from '@h2/components/layout/box'
import { Text } from '@h2/components/typography/text'

const PromotionText = ({ children, variant }) => (
  <Box
    width="60%"
    style={{ maxWidth: '360px' }}
    margin={variant === 'continue' ? '0 0 20px 0' : '0 0 5px 0'}>
    <Text size="medium">{children}</Text>
  </Box>
)

export { PromotionText }
